export const appConfig = {
  backendApiBaseUrl: process.env.REACT_APP_BACKEND_API_BASE_URL!!,
  driveId: process.env.REACT_APP_DRIVE_ID!!,
};
